const { makeStyles } = require("@material-ui/core/styles");

export const useStyles = makeStyles((theme) => ({
  resetBtn: {
    width: 40,
    height: 40,
    borderRadius: 8,
    border: "solid 2px #F0F0F0",
    minWidth: "auto",
    "&:hover": {
      border: "solid 2px #E9954C",
      "& svg": {
        color: "#E9954C !important",
      },
    },
  },
  btnlink: {
    padding: "0",
    minWidth: "40px",
    marginRight: 5,
    border: "solid 1px #C2BDBD",
    borderRadius: 20,
    height: 24,
    background: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
    "&:hover": {
      background: "#fff",
    },
    "& svg": {
      fontSize: 16,
    },
    "&:last-child": {
      marginRight: 0,
    },
    [theme.breakpoints.down("xs")]: {
      marginRight: 10,
    },
  },
  errorMsg: {
    color: "#F36F6F",
    marginBottom: 10,
  },
  rotateIcon: {
    transform: "rotate(-45deg)",
  },
  targetImage: {
    minWidth: 46,
    width: 46,
    height: 28,
    borderRadius: "4px",
    objectFit: "cover",
    display: "block",
    marginRight: 8,
  },
  targetImgDefault: {
    minWidth: 46,
    width: 46,
    height: 28,
    // objectFit: "cover",
    display: "block",
    marginRight: 8,
  },
  statusTxt: {
    color: "#ea8e15",
    width: "max-content",
    fontSize: 11,
    display: "block",
    marginTop: -10,
  },
  targetListingGrid: {
    "& th:first-child": {
      padding: "0 12px",
    },
    // "& $statusNew": {
    //   left: 12
    // }
  },
  targetGroupingGrid: {
    "& tr.k-grouping-row td:nth-child(2) span": {
      display: "none",
    },
    "& tr td": {
      padding: "5px 0px",
    },
  },
  coachProfileOverlap: {
    marginRight: -11,
  },
  coachesInfo: {
    "& .MuiAvatar-root": {
      width: 30,
      height: 30,
    },
  },
  errorAlert: {
    marginBottom: 10,
    fontSize: 13,
    padding: "3px 10px",
  },
  root: {
    width: "100%",
    marginTop: "10px",
    borderCollapse: "collapse",
  },
  rowTitle: {
    color: "#000",
    fontSize: 14,
  },
  actionPopoverList: {
    padding: 0,
    "& li": {
      listStyle: "none",
      "& button": {
        textAlign: "left",
        display: "block",
        width: "100%",
        lineHeight: "18px",
        padding: "8px 15px",
      },
    },
  },
  statusBg: {
    width: 125,
    height: 22,
    color: "#fff",
    borderRadius: 25,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 11,
    // padding:'2px 10px',
  },
  coachInfo: {
    lineHeight: "18px",
  },
  coacheeList: {
    width: 250,
    padding: "6px 15px",
  },
  subTable: {
    margin: "-10px -12px 0",
    width: 1186,
    "& .k-grid-header": {
      display: "none",
    },
    "& .k-master-row": {
      "& td": {
        padding: "8px 12px",
      },
    },
    "& .k-grid-content": {
      padding: "0 !important",
    },
  },
  star: {
    position: "absolute",
    left: -6,
    bottom: -4,
  },
  profileBorder: {
    "& .MuiAvatar-root": {
      border: "solid 2px #BCC9D6",
    },
  },
  avatarImgPic: {
    marginRight: -10,
  },
  removePaddingRight: {
    "& .k-detail-row:hover": {
      background: "unset",
      "& .new-row-bg td": {
        background: "#FFF6EE !important",
      },
      "& .new-row-bg:hover": {
        background: "unset !important",
      },
    },
    padding: "0px 20px 8px 20px",
    [theme.breakpoints.down("xs")]: {
      padding: 8,
    },
    "& td": {
      "& p": {
        "& *": {
          background: "none !important",
          color: "inherit !important",
          fontSize: "13px !important",
          lineHeight: "16px !important",
          margin: 0,
          padding: 0,
          fontFamily: "inherit !important",
          wordBreak: "break-word",
          textDecoration: "none !important",
          fontWeight: "normal !important",
          fontStyle: "normal !important",
        },
      },
    },
    "& .k-grid-header": {
      paddingRight: "17px !important",
    },
    // "& .target-desc": {
    //   height: 32,
    // },
    "& .status-new": {
      position: "absolute",
    },
    "& tr:has(.status-new)": {
      "& .k-icon": {
        "&:after": {
          content: '""',
          background: "#EF7713",
          height: 7,
          width: 7,
          borderRadius: "50%",
          position: "absolute",
          right: -4,
          top: -3,
          zIndex: 1,
        },
      },
    },
    "& .no-data-img": {
      position: "absolute",
      width: "100%",
    },
  },
  tabPadding: {
    padding: "8px 16px",
    [theme.breakpoints.down("xs")]: {
      padding: 8,
      // display: 'block'
      "& .MuiInputBase-root": {
        position: "static !important",
      },
    },
  },
  subTableTitle: {
    fontWeight: 600,
    margin: "6px 0 10px -10px !important",
    textAlign: "left",
    color: "#9f9f9f",
  },
  filterSet: {
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    [theme.breakpoints.down("xs")]: {
      // display: 'block'
    },
  },
  kebabNotif: {
    position: "absolute",
    right: 0,
    "&:after": {
      position: "absolute",
      top: -9,
      right: -6,
      width: 7,
      height: 7,
      borderRadius: "50%",
      background: "#EF7713",
      content: '""',
    },
  },
  submittedTargetAction: {
    "& .kendo-btn .MuiTypography-root": {
      width: 100,
    },
    "& .blank-span": {
      width: "128px !important",
    },
  },
  archivedTargetAction: {
    "& .blank-span": {
      width: "0px !important",
    },
  },
}));
